import React, { Fragment, useEffect } from 'react';
import Breadcrumbs from 'CommonElements/Breadcrumbs';
import DefaultContain from 'Component/DashboardQeza/Product/CategoryProduct';

const CategoryProduct = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Fragment>
            <Breadcrumbs parent="Produk" title="Daftar Kategori Produk" />
            <DefaultContain />
        </Fragment>
    );
};
export default CategoryProduct;